import { useEffect, useState } from 'react';
import { styled } from '@mui/joy';
import packageJson from '../../../../package.json';
import config from '@root/src/config';

interface VersionInfo {
  frontend: string;
  backend: string | null;
  loading: boolean;
  error: string | null;
}

const VersionInfo = () => {
  const [versionInfo, setVersionInfo] = useState<VersionInfo>({
    frontend: packageJson.version,
    backend: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const fetchBackendVersion = async () => {
      try {
        const response = await fetch(`${config.url.urlApi}/status/version`);
        if (response.ok) {
          const data = await response.json();
          setVersionInfo(prev => ({
            ...prev,
            backend: data.version,
            loading: false,
            error: null,
          }));
        } else {
          throw new Error('Failed to fetch backend version');
        }
      } catch (error) {
        setVersionInfo(prev => ({
          ...prev,
          backend: null,
          loading: false,
          error: error instanceof Error ? error.message : 'Unknown error',
        }));
      }
    };

    fetchBackendVersion();
  }, []);

  if (versionInfo.loading) {
    return <Container>Loading...</Container>;
  }

  return (
    <Container>
      <VersionText>v{versionInfo.frontend}</VersionText>
      {versionInfo.backend && <VersionText>• v{versionInfo.backend}</VersionText>}
    </Container>
  );
};

export default VersionInfo;

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '12px',
  padding: '6px 24px',
  color: theme.palette.black,
  backgroundColor: 'transparent',
  marginTop: '16px',
  marginBottom: '8px',
}));

const VersionText = styled('span')({
  fontSize: 'inherit',
  lineHeight: '1.2',
  opacity: 0.6,
});
